import Login from "../../components/login";

function index() {
  return <Login />;
}

export default index;
